import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('StationLog-index-1992f2b7f975ab467-1'),
    routerUrl: '/stationLog',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./StationLogPage')),
    children: [
      //$MORE$
    ],
  },
];
